module.exports = __webpack_public_path__ + "img/hx.678c0110.png";